import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { BehaviorSubject } from 'rxjs'
import { AuthService } from '../auth.service'
import { MatFormField, MatLabel, MatInput, MatPrefix } from '@angular/material/input'
import { AsyncPipe } from '@angular/common'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'

@Component({
    selector: 'app-password-reset-confirm',
    template: `
        <div>
            <h1 class="text-2xl font-bold text-gray-900 mb-1">Set new password</h1>
            <p class="text-sm text-gray-500 mb-8">Choose a strong password for your account</p>

            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-1">
                <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>New Password</mat-label>
                    <mat-icon matPrefix class="mr-2 text-gray-400">lock</mat-icon>
                    <input matInput formControlName="password" type="password" autocomplete="new-password" />
                </mat-form-field>

                @if (error$ | async; as error) {
                    <div class="flex items-center gap-2 text-danger text-sm mb-2 p-3 bg-red-50 rounded-lg">
                        <mat-icon class="!text-base !w-4 !h-4">error_outline</mat-icon>
                        {{ error }}
                    </div>
                }

                <button
                    mat-flat-button
                    type="submit"
                    class="!h-12 !rounded-lg w-full bg-btn-primary text-btn-primary-text"
                    [disabled]="loading$ | async">
                    Reset Password
                </button>
            </form>
        </div>
    `,
    imports: [
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatPrefix,
        MatIcon,
        MatButton,
        AsyncPipe,
    ],
})
export class PasswordResetConfirmComponent implements OnInit {
    form = new FormGroup({
        password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    })

    loading$ = new BehaviorSubject(false)
    error$ = new BehaviorSubject<string | null>(null)
    private token = ''

    constructor(
        private auth: AuthService,
        private route: ActivatedRoute,
        private router: Router,
    ) {}

    ngOnInit() {
        this.token = this.route.snapshot.queryParamMap.get('oobCode') || ''
    }

    onSubmit() {
        if (this.form.invalid || !this.token) return

        this.loading$.next(true)
        this.error$.next(null)

        this.auth.confirmPasswordReset(this.token, this.form.value.password!).subscribe({
            next: () => {
                this.loading$.next(false)
                this.router.navigateByUrl('/login')
            },
            error: (err) => {
                this.loading$.next(false)
                this.error$.next(err?.message || 'Failed to reset password.')
            },
        })
    }
}
